import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";

const DEFAULT_HEADING =
  "85% of edX learners have seen professional growth after earning a certificate";
const DEFAULT_DESCRIPTION =
  "Upgrade your free edX course to a paid course to earn your certificate";

const DEFAULT_IMAGE_SRC = "/bg-images/example-certificate-verified.webp";

interface VerificationUpsellProps {
  heading?: string;
  description?: string;
  imageSrc?: string;
}

export default function VerificationUpsell({
  heading = DEFAULT_HEADING,
  description = DEFAULT_DESCRIPTION,
  imageSrc = DEFAULT_IMAGE_SRC,
}: VerificationUpsellProps) {
  const t = useTranslations("Common");
  return (
    <div className="bg-primary-500 mb-6 rounded-xl">
      <div className="flex flex-col md:flex-row items-center p-6 md:p-12 gap-6 md:gap-12">
        <div className="flex flex-col gap-6 md:flex-[2]">
          <h2 className="text-2xl text-white md:text-3xl font-bold leading-tight m-0">
            {heading}
          </h2>
          <p className="text-lg md:text-xl text-gray-100 m-0">{description}</p>
        </div>
        <div className="flex justify-center md:flex-[1.5]">
          <div className="w-full">
            <Image
              src={imageSrc}
              alt={t("verificationUpsellBannerAlt")}
              width={400}
              height={300}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
